import { BreadcrumbTrailElement } from './BreadcrumbTrail.element'
if (!window.customElements.get('breadcrumb-trail')) {
  window.customElements.define('breadcrumb-trail', BreadcrumbTrailElement)
}
